export default "__VITE_ASSET__GnkfXG0a__"